<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 12 16"
       :aria-labelledby="iconName"
       role="presentation"
  >
    <g :fill="iconColor">
      <path d="M3.44,10.57a3.63,3.63,0,0,1,0-5.13,3.72,3.72,0,0,1,5.13,0l-.71.71a2.69,2.69,
        0,0,0-3.72,0,2.63,2.63,0,0,0,0,3.72Z"
      />
      <rect x="1.7" y="3.34"
            width="1" height="1.71"
            transform="translate(-2.32 2.78) rotate(-44.99)"/>
      <g>
        <rect y="7.24" width="1.71" height="1"/>
        <rect x="5.24" y="2" width="1" height="1.71"/>
      </g>
      <path d="M6.2,14a5.78,5.78,0,0,1-4.1-1.7l-.84-.84,1.19,0a8.05,8.05,0,0,0,
        5-2,8.05,8.05,0,0,0,2-5l0-1.19.84.84A5.8,5.8,0,0,1,6.2,14ZM3.72,12.31a4.8,4.8,
        0,0,0,6.59-6.59,8.35,8.35,0,0,1-2.16,4.43A8.35,8.35,0,0,1,3.72,12.31Z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
<style scoped>
  svg {
    display: inline-block;
    vertical-align: baseline;
  }
</style>
